import { render, staticRenderFns } from "./scholarship.vue?vue&type=template&id=eda90e64&"
import script from "./scholarship.vue?vue&type=script&lang=js&"
export * from "./scholarship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports